import Paginate from './Paginate'

module.exports = Paginate
